"use client";

import { useState, useCallback } from "react";
import { createPortal } from "react-dom";
import MuxPlayer from "@mux/mux-player-react";
import WayysLogo from "@/components/WayysLogo";
import { Play, X } from "lucide-react";

const PLAYBACK_ID = "ICexAW5YHNShN3zGz9hU6LUbIJ4iV7f4N9buWs1rMLI";

export default function WayysVideo() {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
    document.body.style.overflow = "hidden";
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
    document.body.style.overflow = "";
  }, []);

  return (
    <>
      <div
        onClick={handleOpen}
        className="overflow-hidden group w-full h-full absolute left-0 top-0 cursor-pointer"
      >
        <MuxPlayer
          playbackId={PLAYBACK_ID}
          autoPlay="muted"
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover"
          style={{
            "--controls": "none",
            "--media-object-fit": "cover",
            "--media-object-position": "center",
            aspectRatio: "unset",
          }}
        />
        <div className="flex px-2 md:px-4 items-center justify-between duration-300 ease-in-out bg-linear-to-b from transparent to-black absolute bottom-0 left-0 w-full h-8 md:h-12">
          <div aria-label="Play video fullscreen">
            <Play className="text-white size-4" fill="currentColor" />
          </div>
          <div className="flex gap-1 items-center">
            <p className="text-white font-bold text-xxs md:text-xs">Coach @</p>
            <WayysLogo className="text-white w-12" />
          </div>
        </div>
      </div>

      {open &&
        createPortal(
          <div
            className="fixed inset-0 z-[99999] bg-black/90 flex items-center justify-center"
            onClick={handleClose}
          >
            <button
              onClick={handleClose}
              className="absolute top-6 right-6 text-white cursor-pointer hover:opacity-70 transition-opacity"
              aria-label="Close video"
            >
              <X size={32} />
            </button>
            <div
              className="w-full max-w-5xl aspect-video"
              onClick={(e) => e.stopPropagation()}
            >
              <MuxPlayer
                playbackId={PLAYBACK_ID}
                autoPlay
                className="w-full h-full"
              />
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
